import axios from "axios";

const API_URL =  `${process.env.REACT_APP_API_URL}/paiements`; 

// =====================================================
// GET TOUS LES PAIEMENTS
// =====================================================
export const getPaiements = async () => {
    const response = await axios.get(API_URL);
    return response.data;
};

export const getProfitTotal = async () => {
    const response = await axios.get(`${API_URL}/profit-total`);

    return response.data;
};
// =====================================================
// GET UN PAIEMENT PAR ID
// =====================================================
export const getPaiementById = async (id) => {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
};


// =====================================================
// CREATE PAIEMENT
// =====================================================
export const createPaiement = async (data) => {
    const response = await axios.post(API_URL, data);
    return response.data;
};


// =====================================================
// GET PAIEMENTS PAR RENDEZ-VOUS
// =====================================================
export const getPaiementsByRendezVous = async (rendez_vous_id) => {
    const response = await axios.get(
        `${API_URL}/rendez-vous/${rendez_vous_id}`
    );

    return response.data;
};


// =====================================================
// UPDATE PAIEMENT
// =====================================================
export const updatePaiement = async (id, data) => {
    const response = await axios.put(
        `${API_URL}/${id}`,
        data
    );

    return response.data;
};


// =====================================================
// DELETE PAIEMENT
// =====================================================
export const deletePaiement = async (id) => {
    const response = await axios.delete(
        `${API_URL}/${id}`
    );

    return response.data;
};